import React from 'react'
import {Form, Button, Layout, Modal, message, Spin } from 'antd';
import './css/Customers.css';
import '../../router.js';
import HeaderNav from "../header/header";
import Template1 from "./wepcg/Template1";
import DropDownBox from "./DropDownBox";
import EligibleLateDeliveryBar from './wepcg/sidebar/eligibleLateDelivery_bar';
import LostUnitsBar from "./wepcg/sidebar/lostUnits_bar";
import PricingErrorBar from "./wepcg/sidebar/pricingError_bar"
import RebillBar from "./wepcg/sidebar/rebill_bar";
import ServiceSoftwareCancellationBar from "./wepcg/sidebar/serviceSoftwareCancellation_bar";
import BoxDamageBar from "./wepcg/sidebar/boxDamage_bar";
import DeadOnArrivalBar from "./wepcg/sidebar/deadOnArrival_bar";
import FaultyOptionsUnderWarrantyBar from "./wepcg/sidebar/faultyOptionsUnderWarranty";
import ProductDamageBar from "./wepcg/sidebar/productDamage_bar";
import OtherBar from "./wepcg/sidebar/other_bar";
import PriceProtectionDisputeBar from "./wepcg/sidebar/priceProtectionDispute_bar";
import {invoice_table_data,dispute_submit} from "../../requist";
import moment from "moment";
import '../../page/components/css/load.css'

const { Content, Sider } = Layout;

class WEPCGCustomers extends React.Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            key:null,
            checked_state:false,
            selectedRowKeys:[],
            isModalVisible: false,
            MsgModalVisible:false,
            invoice_number:null,
            serial_number:null,
            rebillTitle:'Invoice Correction / Rebill  Required Information',
            lostUnitsTitle:'Missing Goods Required Information',
            boxDamageTitle:'Damage in Transit Claim Submission Required Information',
            productDamageTitle:'Product Damage Claim Submission Required Information',
            pricingErrorTitle:'Pricing Error Claim Required Information',
            InvoiceClaimMsg:true,
            optionList:[],
            ValidateData:[],
            loading:false,
            disputeType:'',
            isSKID:false,
            disputeTypeText:'',
            PPMass_checked:false,
            selectAllData:[],
            fieldKey:null,
            selectedRows:[],
            totalAmountValue:null,
            MassUploadData:[]
        }
        //下拉框数据
        this.optionList=[
            {value:'Please select',key:'0'},
            {value:'Invoice Dispute (Eligible Late Delivery)',key:'1'},
            {value:'Invoice Dispute (Lost Units)',key:'2'},
            {value:'Invoice Dispute (Pricing Error)',key:'3'},
            {value:'Invoice Dispute (Rebill)',key:'4'},
            {value:'Invoice Dispute (Service & Software Cancellation)',key:'5'},
            {value:'Return Request (Box Damage)',key:'6'},
            {value:'Return Request (Dead On Arrival)',key:'7'},
            {value:'Return Request (Faulty Options Under Warranty)',key:'8'},
            {value:'Return Request (Missing & Incorrect Parts Request)',key:'9'},
            {value:'Return Request (Product Damage)',key:'10'},
            {value:'Return Request (Other)',key:'11'},
            {value:'BID Rebates Dispute',key:'12'},
            {value:'Price Protection Dispute',key:'13'},
        ]
        //checked The whole invoice claim
        this.getInvoiceClaim=(e)=>{
            let targetAttr = e.target.ownerDocument.activeElement.attributes
            let fieldKey = targetAttr.fieldKey?Number(targetAttr.fieldKey.value) + 2:1
            let InvoiceValue = e.target.ownerDocument.activeElement.attributes.value.value
            let invoice_number = this.formRef.current.getFieldValue('invoiceNumber')
            let serial_number = this.formRef.current.getFieldValue('serialNumber')
            let pcsBpId = window.localStorage.getItem('pcsdBpId');
            let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
            if(InvoiceValue){
                this.setState({loading:true})
                let {selectedRows,key} = this.state
                invoice_table_data(InvoiceValue,serial_number,'WE','P',userInfo.source).then((res)=>{
                    if(res.retCode==='200'){
                        this.setState({totalAmountValue:res.data.totalAmountValue,soldToCountry:res.data.country})
                        if(userInfo.source==='external'){
                            let soto = res.data.invoiceItems[0].soldToNumber
                            if(pcsBpId === soto){
                                res.data.invoiceItems.forEach((item,index)=>{
                                    if(item.serialNumbers){
                                        if(item.serialNumbers.length>1 && this.state.key!=7){
                                            item.serialNumbers=[]
                                        }
                                    }
                                    item.companyCode = res.data.companyCode
                                    res.data.invoiceItems[index] = {id:item.invoiceNumber+item.invoiceItemNo,...item}
                                })
                                // let allData = selectedRows.concat(res.data.invoiceItems)
                                let allData=[]
                                if(selectedRows.length){
                                    if(fieldKey>selectedRows.length){
                                        allData = selectedRows.concat(res.data.invoiceItems)
                                    }else if(fieldKey===1 && selectedRows.length===1){
                                        allData = res.data.invoiceItems
                                    }else if(fieldKey===1 && selectedRows.length>1){
                                        allData = res.data.invoiceItems.concat(selectedRows.splice(1,1))
                                    }else{
                                        if(fieldKey+res.data.invoiceItems.length-1>selectedRows.length){  //去掉一个替换成多个
                                            allData = selectedRows.splice(fieldKey-1,1).concat(res.data.invoiceItems)
                                        }else{
                                            allData = selectedRows.fill(...res.data.invoiceItems,fieldKey-1,fieldKey+res.data.invoiceItems.length-1)
                                        }
                                    }
                                }else{
                                    allData = selectedRows.concat(res.data.invoiceItems)
                                }
                                const res_map = new Map();
                                allData = allData.filter((a)=>!res_map.has(a['id'])&& res_map.set(a['id'],1))
                                this.setState({selectedRows: allData})
                                if(allData.length>1){
                                    let sliceData = allData.slice(1,allData.length)
                                    let data_netValue = allData[0].netValueUnit?allData[0].netValueUnit:0
                                    let data_quantity = allData[0].quantity?allData[0].quantity:0
                                    let total = (data_netValue * data_quantity).toFixed(2)
                                    let sold_to = allData[0].soldToNumber
                                    this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:total?total:0,creditAmountUnit:res.data.invoiceItems[0].netValueUnit,...allData[0]})
                                    this.formRef.current.setFieldsValue({ template1:
                                            sliceData.map(item=>{
                                                let t_data_sold_to = item.soldToNumber
                                                if(t_data_sold_to!==sold_to){
                                                    message.warn('Sold to should to be same in one dispute, pls check!')
                                                }
                                                let t_total=((item.netValueUnit?item.netValueUnit:0)*(item.quantity?item.quantity:0)).toFixed(2)
                                                return {requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:t_total?t_total:0,invoiceNumber:invoice_number,serialNumber:serial_number,creditAmountUnit:item.netValueUnit,...item}
                                            })})
                                }else if(allData.length===1){
                                    let data_netValue=allData[0].netValueUnit?allData[0].netValueUnit:0
                                    let data_quantity=allData[0].quantity?allData[0].quantity:0
                                    let total = (data_netValue * data_quantity).toFixed(2)
                                    this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:total?total:0,creditAmountUnit:allData[0].netValueUnit,...allData[0]})
                                }
                                this.setState({loading:false})
                            }else{
                                this.formRef.current.resetFields()
                                this.formRef.current.setFieldsValue({invoiceNumber:InvoiceValue})
                                this.setState({InvoiceClaimMsg:true,loading:false})
                            }
                        }else{
                            res.data.invoiceItems.forEach((item,index)=>{
                                if(item.serialNumbers){
                                    if(item.serialNumbers.length>1 && this.state.key!=7){
                                        item.serialNumbers=[]
                                    }
                                }
                                res.data.invoiceItems[index] = {id:item.invoiceNumber+item.invoiceItemNo,...item}
                            })
                            // let allData = selectedRows.concat(res.data.invoiceItems)
                            let allData=[]
                            if(selectedRows.length){
                                if(fieldKey>selectedRows.length){
                                    allData = selectedRows.concat(res.data.invoiceItems)
                                }else if(fieldKey===1 && selectedRows.length===1){
                                    allData = res.data.invoiceItems
                                }else if(fieldKey===1 && selectedRows.length>1){
                                    allData = res.data.invoiceItems.concat(selectedRows.splice(1,1))
                                }else{
                                    if(fieldKey+res.data.invoiceItems.length-1>selectedRows.length){  //去掉一个替换成多个
                                        allData = selectedRows.splice(fieldKey-1,1).concat(res.data.invoiceItems)
                                    }else{
                                        allData = selectedRows.fill(...res.data.invoiceItems,fieldKey-1,fieldKey+res.data.invoiceItems.length-1)
                                    }
                                }
                            }else{
                                allData = selectedRows.concat(res.data.invoiceItems)
                            }
                            const res_map = new Map();
                            allData = allData.filter((a)=>!res_map.has(a['id'])&& res_map.set(a['id'],1))
                            this.setState({selectedRows: allData})
                            if(allData.length>1){
                                let sliceData = allData.slice(1,allData.length)
                                let data_netValue = allData[0].netValueUnit?allData[0].netValueUnit:0
                                let data_quantity = allData[0].quantity?allData[0].quantity:0
                                let total = (data_netValue * data_quantity).toFixed(2)
                                let sold_to = allData[0].soldToNumber
                                this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:total?total:0,creditAmountUnit:res.data.invoiceItems[0].netValueUnit,...allData[0]})
                                this.formRef.current.setFieldsValue({ template1:
                                        sliceData.map(item=>{
                                            let t_data_sold_to = item.soldToNumber
                                            if(t_data_sold_to!==sold_to){
                                                message.warn('Sold to should to be same in one dispute, pls check!')
                                            }
                                            if(key===1 || key===3){
                                                let t_total=((item.netValueUnit?item.netValueUnit:0)*(item.quantity?item.quantity:0)).toFixed(2)
                                                return {requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:t_total?t_total:0,invoiceNumber:invoice_number,serialNumber:serial_number,creditAmountUnit:item.netValueUnit,...item}
                                            }else{
                                                let t_total=((item.netValueUnit?item.netValueUnit:0)*(item.quantity?item.quantity:0)).toFixed(2)
                                                return {requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:t_total?t_total:0,invoiceNumber:invoice_number,serialNumber:serial_number,creditAmountUnit:item.netValueUnit,...item,quantity:''}
                                            }

                                        })})
                            }else if(allData.length===1){
                                let data_netValue=allData[0].netValueUnit?allData[0].netValueUnit:0
                                let data_quantity=allData[0].quantity?allData[0].quantity:0
                                let total = (data_netValue * data_quantity).toFixed(2)
                                if(key===1 || key===3){
                                    this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:total?total:0,creditAmountUnit:allData[0].netValueUnit,...allData[0]})
                                }else{
                                    this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,creditAmountTotal:total?total:0,creditAmountUnit:allData[0].netValueUnit,...allData[0],quantity:''})
                                }
                            }
                            this.setState({loading:false})
                        }
                    }else if(res.retCode==='100'){
                        message.error(`${res.retMsg}`)
                        this.setState({loading:false})
                    }
                })
            }else{
                this.formRef.current.validateFields(['invoiceNumber'])
            }
        }

        this.callback=()=>{
            //form表单的第一个item可以直接取值，其他的item作为数据存在 template1中
            let {selectedRows,ValidateData,selectAllData,fieldKey,key} = this.state;
            //取出当前页面的值
            let {template1,...item1} = this.formRef.current.getFieldsValue()
            let currentItems = [];
            if(item1.partNumber){
                currentItems.push(item1);
                if(template1) {
                    currentItems = currentItems.concat(template1)
                }
            }
            if(currentItems.length>0) {
                //遍历当前存储的数据，替换其中可以更新的字段
                selectAllData.forEach((item, index)=>{
                    let currentDataItem = currentItems[index];
                    //当前用户填写的字段替换当前存储的字段值
                    if(currentDataItem.serialNumbers ){
                        item.serialNumbers = []
                        item.serialNumbers.push(currentDataItem.serialNumbers)
                    }
                    if(currentDataItem.serialNumber ){
                        item.serialNumber = currentDataItem.serialNumber
                    }
                    if(currentDataItem.biosPassword){
                        item.biosPassword = currentDataItem.biosPassword
                    }
                    if(currentDataItem.currency){
                        item.currency = currentDataItem.currency
                    }
                    if(currentDataItem.productDamaged){
                        item.productDamaged = currentDataItem.productDamaged
                    }
                    if(currentDataItem.caseId){
                        item.caseId = currentDataItem.caseId
                    }
                    if(currentDataItem.doaConfirmNo){
                        item.doaConfirmNo = currentDataItem.doaConfirmNo
                    }
                    if(currentDataItem.priceDropDate){
                        item.priceDropDate = currentDataItem.priceDropDate
                    }
                    if(currentDataItem.quantity){
                        item.quantity = currentDataItem.quantity
                    }
                    if(currentDataItem.creditAmountUnit){
                        item.creditAmountUnit = currentDataItem.creditAmountUnit
                    }
                    if(currentDataItem.creditAmountTotal){
                        item.creditAmountTotal = currentDataItem.creditAmountTotal
                    }
                })
            }
            let serial_number = this.formRef.current.getFieldValue('serialNumber')
            //复制quantity字段为maxQuantity
            selectedRows = selectedRows.map((item)=>{
                let{quantity, ...tempItem} = item
                let maxQuantity = quantity;
                if(key!==2 && key!==3){
                    quantity = '';
                }
                return {quantity, maxQuantity, ...tempItem}
            })
            
            let allData=[];
            if(selectAllData.length){
                if(fieldKey>selectAllData.length){
                    allData = selectAllData.concat(selectedRows)
                }else if(fieldKey===1 && selectAllData.length===1){
                    allData = selectedRows
                }else if(fieldKey===1 && selectAllData.length>1){
                    allData = selectedRows.concat(selectAllData.splice(1,1))
                }else{
                    if(fieldKey+selectedRows.length-1>selectAllData.length){  //去掉一个替换成多个
                        allData = selectAllData.splice(fieldKey-1,1).concat(selectedRows)
                    }else{
                        allData = selectAllData.fill(...selectedRows,fieldKey-1,fieldKey+selectedRows.length-1)
                    }
                }
            }else{
                allData = selectAllData.concat(selectedRows)
            }
            this.setState({selectAllData:allData})
            let selectedRow = allData.map(item=>{
                if(item.serialNumbers){
                    if(item.serialNumbers.length>1 && this.state.key!=7){
                        item.serialNumbers=[]
                    }
                }
                let data_netValue=item.netValueUnit?item.netValueUnit:0
                let data_quantity=item.quantity?item.quantity:0
                let total = (data_netValue * data_quantity).toFixed(2)
                if(this.state.key=="7"){
                    return {id:item.serialNumbers[0],creditAmountTotal:total?total:0,serialNumber:item.serialNumbers[0],creditAmountUnit:item.netValueUnit,...item}
                }else{
                    return {id:item.invoiceNumber+item.invoiceItemNo,creditAmountTotal:total?total:0,serialNumber:serial_number,creditAmountUnit:item.netValueUnit,...item}
                }
            })

            const res_map = new Map();
            selectedRow = selectedRow.filter((a)=>!res_map.has(a['id'])&& res_map.set(a['id'],1))
            this.setState({selectedRows:selectedRow})
            if(selectedRow?.length>1){
                let sliceData = selectedRow.slice(1,selectedRow.length)
                if(key===1 || key===3){
                    this.formRef.current.setFieldsValue({requesterCountry:ValidateData.country,contactPersonCountry:ValidateData.country,...selectedRow[0]})
                    this.formRef.current.setFieldsValue({ template1: sliceData})
                }else{
                    this.formRef.current.setFieldsValue({requesterCountry:ValidateData.country,contactPersonCountry:ValidateData.country,...selectedRow[0]})
                    this.formRef.current.setFieldsValue({ template1: sliceData})
                }
                let sold_to = selectedRow[0].soldToNumber
                sliceData.forEach(item=>{
                    let t_data_sold_to = item.soldToNumber
                    if(t_data_sold_to!==sold_to){
                        message.warn('Sold to should to be same in one dispute, pls check!')
                    }
                })
            }else if(selectedRow){
                this.formRef.current.setFieldsValue({requesterCountry:ValidateData.country,contactPersonCountry:ValidateData.country,...selectedRow[0]})
            }
            this.setState({isModalVisible:false,ModalVisible:false,selectedRowKeys: []})
        }

    }
    componentWillMount(){
        let uesrId = window.localStorage.getItem('userId')
        if(!uesrId){
            message.warn('Please log in first!')
            this.props.history.push({
                pathname: '/disputeHome'
            })
        }
    }
    PPMass=(checked)=>{
        this.setState({PPMass_checked:checked})
    }
    dataChecked = (selectedRowKeys,selectedRows) =>{
        this.setState({ selectedRowKeys: selectedRowKeys, selectedRows})
    }
    handleCancel = () =>{
        this.setState({isModalVisible:false,selectedRowKeys: [],selectAllData:[],ValidateData:[]})
    }
    ModalVisible=(e)=>{
        let targetAttr = e.target.ownerDocument.activeElement.attributes
        this.setState({fieldKey:targetAttr.fieldKey?Number(targetAttr.fieldKey.value) + 2:1})
        let invoice_number = this.formRef.current.getFieldValue('invoiceNumber')?this.formRef.current.getFieldValue('invoiceNumber'):''
        let serial_number = this.formRef.current.getFieldValue('serialNumber')?this.formRef.current.getFieldValue('serialNumber'):''
        let pcsBpId = window.localStorage.getItem('pcsdBpId');
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if(invoice_number || serial_number){
            this.setState({loading:true})
            let InvoiceValue='',serialValue='';
            if(invoice_number){
                if(this.state.key===7){ //DOA
                    InvoiceValue=""
                    serialValue=e.target.ownerDocument.activeElement.attributes.value.value
                }else {
                    serialValue=''
                    InvoiceValue = e.target.ownerDocument.activeElement.attributes.value.value
                }
            }else if(serial_number){
                InvoiceValue=''
                serialValue=e.target.ownerDocument.activeElement.attributes.value.value
            }
            this.setState({invoice_number:InvoiceValue,serial_number:serialValue})
            invoice_table_data(InvoiceValue,serialValue,'WE','P',userInfo.source).then((res)=>{
                if(res.retCode==="200"){
                    this.setState({totalAmountValue:res.data.totalAmountValue,soldToCountry:res.data.country})
                    if(res.data.invoiceItems.length>0){
                        res.data.invoiceItems.forEach(item=>{
                            item.companyCode = res.data.companyCode
                        })
                    }
                    if(userInfo.source==='external'){
                        let soto = res.data.soldToNumber
                        if(pcsBpId === soto){
                            this.setState({ValidateData:res.data})
                            this.setState({isModalVisible:true})
                            this.setState({loading:false})
                        }else{
                            this.formRef.current.resetFields()
                            this.formRef.current.setFieldsValue({invoiceNumber:InvoiceValue})
                            this.setState({InvoiceClaimMsg:true,loading:false})
                        }
                    }else{
                        this.setState({ValidateData:res.data})
                        this.setState({isModalVisible:true})
                        this.setState({loading:false})
                    }
                }else if(res.retCode==='100'){
                    message.error(`${res.retMsg}`)
                    this.setState({loading:false})
                }
            })
        }else{
            this.formRef.current.validateFields(['invoiceNumber'])
            this.formRef.current.validateFields(['SerialNumber'])
        }
    }
    onRebillInvoice(e){
        let InvoiceValue = e.target.ownerDocument.activeElement.attributes.value.value
        // let invoice_number = this.formRef.current.getFieldValue('invoiceNumber')
        let targetAttr = e.target.ownerDocument.activeElement.attributes
        let fieldKey = targetAttr.fieldKey?Number(targetAttr.fieldKey.value) + 2:1
        let serial_number = this.formRef.current.getFieldValue('serialNumber')
        let pcsBpId = window.localStorage.getItem('pcsdBpId');
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if(InvoiceValue){
            this.setState({loading:true})
            let {selectedRows} = this.state
            invoice_table_data(InvoiceValue,serial_number,'WE','P',userInfo.source).then((res)=>{
                if(res.retCode==='200'){
                    this.setState({totalAmountValue:res.data.totalAmountValue,soldToCountry:res.data.country})
                    if(res.data.invoiceItems.length>0){
                        res.data.invoiceItems.forEach(item=>{
                            item.companyCode = res.data.companyCode
                        })
                    }
                    // let allData = selectedRows.concat(res.data)
                    let allData=[]
                    if(selectedRows.length){
                        if(fieldKey>selectedRows.length){
                            allData = selectedRows.concat(res.data)
                        }else if(fieldKey===1 && selectedRows.length===1){
                            allData = [res.data]
                        }else if(fieldKey===1 && selectedRows.length>1){
                            allData = [res.data].concat(selectedRows.splice(1,1))
                        }else{
                            if(fieldKey+[res.data].length-1>selectedRows.length){  //去掉一个替换成多个
                                allData = selectedRows.splice(fieldKey-1,1).concat(res.data)
                            }else{
                                allData = selectedRows.fill(res.data,fieldKey-1,fieldKey+[res.data].length-1)
                            }
                        }
                    }else{
                        allData = selectedRows.concat(res.data)
                    }
                    // const res_map = new Map();
                    // allData = allData.filter((a)=>!res_map.has(a['id'])&& res_map.set(a['id'],1))
                    if(userInfo.source==='external'){
                        let soto = res.data.soldToNumber
                        if(pcsBpId === soto){
                            this.setState({selectedRows: allData})
                            if(allData.length>1){
                                let sliceData = allData.slice(1,allData.length)
                                // let data_netValue = allData[0].netValueUnit?allData[0].netValueUnit:0
                                // let data_quantity = allData[0].quantity?allData[0].quantity:0
                                // let total = data_netValue * data_quantity
                                let sold_to = allData[0].soldToNumber
                                this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,...res.data[0]})
                                this.formRef.current.setFieldsValue({ template1:
                                        sliceData.map(item=>{
                                            let t_data_sold_to = item.soldToNumber
                                            if(t_data_sold_to!==sold_to){
                                                message.warn('Sold to should to be same in one dispute, pls check!')
                                            }
                                            return {currency:item.invoiceItems[0].currency,...item}
                                        })})
                            }else if(allData.length===1){
                                this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,currency:res.data.invoiceItems[0].currency,...res.data})
                            }
                            this.setState({loading:false})
                        }else{
                            this.formRef.current.resetFields()
                            this.formRef.current.setFieldsValue({invoiceNumber:InvoiceValue})
                            this.setState({InvoiceClaimMsg:true,loading:false})
                        }
                    }else {
                        this.setState({selectedRows: allData})
                        if(allData.length>1){
                            let sliceData = allData.slice(1,allData.length)
                            // let data_netValue = allData[0].netValueUnit?allData[0].netValueUnit:0
                            // let data_quantity = allData[0].quantity?allData[0].quantity:0
                            // let total = data_netValue * data_quantity
                            let sold_to = allData[0].soldToNumber
                            this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,...res.data[0]})
                            this.formRef.current.setFieldsValue({ template1:
                                    sliceData.map(item=>{
                                        let t_data_sold_to = item.soldToNumber
                                        if(t_data_sold_to!==sold_to){
                                            message.warn('Sold to should to be same in one dispute, pls check!')
                                        }
                                        return {requesterCountry:res.data.country,currency:item.invoiceItems[0].currency,...item}
                                    })})
                        }else if(allData.length===1){
                            this.formRef.current.setFieldsValue({requesterCountry:res.data.country,contactPersonCountry:res.data.country,currency:res.data.invoiceItems[0].currency,...res.data})
                        }
                        this.setState({loading:false})
                    }
                }else if(res.retCode==='100'){
                    message.error(`${res.retMsg}`)
                    this.setState({loading:false})
                }
            })
        }else{
            this.formRef.current.validateFields(['invoiceNumber'])
        }
    }
    onCreditAmountTotal(e,fieldKey){
        let {selectedRows, selectAllData}=this.state;
        let quantity = this.formRef.current.getFieldValue('quantity')
        if(selectedRows.length){
            if(quantity>selectedRows[0].maxQuantity){
                this.formRef.current.setFieldsValue({quantity:selectedRows[0].maxQuantity})
                message.warn('The quantity '+quantity+' is more than invoice origin quantity '+selectedRows[0].maxQuantity+'')
            }else{
                let creditAmountUnit = this.formRef.current.getFieldValue('creditAmountUnit')
                let total=(quantity*creditAmountUnit).toFixed(2)
                total = total?total:'';
                this.formRef.current.setFieldsValue({creditAmountTotal:total})
                this.setState({selectAllData})
            }
        }
        //add CreditAmountTotal
        let newData = this.formRef.current.getFieldValue('template1')?this.formRef.current.getFieldValue('template1'):[]
        if(newData[fieldKey] && newData.length>0){
            let itemQuantity = newData[fieldKey].hasOwnProperty('quantity')?newData[fieldKey].quantity:newData[fieldKey].quantity=''
            if(itemQuantity>selectedRows[fieldKey+1].maxQuantity){
                newData[fieldKey]={...newData[fieldKey],quantity:selectedRows[fieldKey+1].maxQuantity}
                this.formRef.current.setFieldsValue({template1:newData})
                message.warn('The quantity '+itemQuantity+' is more than invoice origin quantity '+selectedRows[fieldKey+1].maxQuantity+'')
            }else{
                let itemCreditAmountUnit = newData[fieldKey].hasOwnProperty('creditAmountUnit')?newData[fieldKey].creditAmountUnit:newData[fieldKey].creditAmountUnit=''
                let itemTotal=(itemQuantity*itemCreditAmountUnit).toFixed(2)
                itemTotal = itemTotal?itemTotal:'';
                newData[fieldKey]={...newData[fieldKey],creditAmountTotal:itemTotal}
                this.formRef.current.setFieldsValue({template1:newData})
                this.setState({selectAllData})
            }

        }
    }
    handleChange=(v,d)=>{
        this.setState({
            disputeType:v,
            disputeTypeText:d.children,
            selectedRows:[],
            selectAllData:[],
            ValidateData:[],
            invoice_number:"",
            InvoiceClaimMsg:false
        })
        if(v==="REBI" || v==="LOST" || v==="RBOX" || v==="RPRD" || v==="PRIE"){
            this.setState({MsgModalVisible:true})
        }
        if(v==="ELLD"){
            this.setState({key:1})
        }else if(v==="LOST"){
            this.setState({key:2})
        }else if(v==="PRIE"){
            this.setState({key:3})
        }else if(v==="REBI"){
            this.setState({key:4})
        }else if(v==="SESC"){
            this.setState({key:5})
        }else if(v==="RBOX"){
            this.setState({key:6})
        }else if(v==="RDOA"){
            this.setState({key:7})
        }else if(v==="FOUW"){
            this.setState({key:8})
        }else if(v==="RMIP"){
            this.setState({key:9})
        }else if(v==="RPRD"){
            this.setState({key:10})
        }else if(v==="ROTH"){
            this.setState({key:11})
        }else if(v==="BIRD"){
            this.setState({key:12})
        }else if(v==="PPRD"){
            this.setState({key:13})
        }
        this.formRef.current.resetFields()
    };
    //转成浮点数

    returnFloat(value){
        value=Math.round(parseFloat(value)*100)/100;
        var s=value.toString().split(".");
        if(s.length===1){
            value=value.toString()+".00";
            return value;
        }
        if(s.length>1){
            if(s[1].length<2){
                value=value.toString()+"0";
            }
            return value;
        }
    }
    SKID(value){
        this.setState({isSKID:value})
    }
    MassUploadData(data){
        if(this.state.key===4){
            this.setState({MassUploadData:data.map(item=>{
                    return {
                        ...item,
                        creditAmountUnit:'',
                        quantity:'',
                        creditAmountTotal:item.totalAmountValue
                    }
                }),soldToCountry:data[0].soldToCountry})
        }else{
            this.setState({MassUploadData:data,soldToCountry:data[0].soldToCountry})
        }
        this.formRef.current.setFieldsValue({requesterCountry:data[0].soldToCountry,contactPersonCountry:data[0].soldToCountry})
    }
    deleteData(e){
        const {selectAllData,selectedRows}=this.state
        let index = e + 1
        //删除当前选中元素
        selectAllData.splice(index,1)
        this.setState({selectAllData})
        selectedRows.splice(index,1)
        this.setState({selectedRows})
    }
    deleteFirstData(e){
        const {selectedRows,soldToCountry} = this.state;
        let newSelectRows=[];
        if(selectedRows[0]){
            selectedRows.forEach((item,index)=>{
                if(index===0){
                }else{
                    newSelectRows.push(item)
                }
            })
            this.setState({selectedRows:newSelectRows})
            if(newSelectRows.length>1){
                let sliceData = newSelectRows.slice(1,newSelectRows.length)
                let data_netValue = newSelectRows[0].netValueUnit?newSelectRows[0].netValueUnit:0
                let data_quantity = newSelectRows[0].quantity?newSelectRows[0].quantity:0
                let total = (data_netValue * data_quantity).toFixed(2)
                let sold_to = newSelectRows[0].soldToNumber
                this.formRef.current.setFieldsValue({requesterCountry:soldToCountry,contactPersonCountry:soldToCountry,creditAmountTotal:total?total:0,creditAmountUnit:newSelectRows[0].netValueUnit,...newSelectRows[0]})
                this.formRef.current.setFieldsValue({ template1:
                        sliceData.map(item=>{
                            let t_data_sold_to = item.soldToNumber
                            if(t_data_sold_to!==sold_to){
                                message.warn('Sold to should to be same in one dispute, pls check!')
                            }
                            let t_total=((item.netValueUnit?item.netValueUnit:0)*(item.quantity?item.quantity:0)).toFixed(2)
                            return {requesterCountry:soldToCountry,contactPersonCountry:soldToCountry,soldToCountry:soldToCountry,creditAmountTotal:t_total?t_total:0,invoiceNumber:item.invoiceNumber,serialNumber:item.serialNumber,creditAmountUnit:item.netValueUnit,...item}
                        })})
            }else if(newSelectRows.length===1){
                let data_netValue=newSelectRows[0].netValueUnit?newSelectRows[0].netValueUnit:0
                let data_quantity=newSelectRows[0].quantity?newSelectRows[0].quantity:0
                let total = (data_netValue * data_quantity).toFixed(2)
                this.formRef.current.setFieldsValue({requesterCountry:soldToCountry,contactPersonCountry:soldToCountry,soldToCountry:soldToCountry,creditAmountTotal:total?total:0,creditAmountUnit:newSelectRows[0].netValueUnit,...newSelectRows[0]})
                this.formRef.current.setFieldsValue({template1:[]})
            }else if(newSelectRows.length===0){
                this.formRef.current.resetFields()
            }
        }
    }
    onFinish = (values) => {
        const {disputeType,selectedRows,disputeTypeText} = this.state;
        this.setState({loading:true})
        let invoiceInfos=[];
        let quantity=null;
        let creditAmountTotal = '';
        let creditAmountUnit = '';
        // let check = 1;
        let createdBy = window.localStorage.getItem('userId');
        if(this.state.isSKID){
            values={
                ...values,
                contactPerson:'IRR',
                contactPersonPhone:'IRR',
                contactPersonEmail:'IRR',
                contactPersonCompany:'IRR',
                contactPersonStreet:'IRR',
                contactPersonZipCode:'IRR',
            }
        }
        selectedRows.forEach((item,index)=>{
            if(index){
                quantity = this.formRef.current.getFieldValue('template1')[index-1].quantity
                creditAmountTotal = this.formRef.current.getFieldValue('template1')[index-1].creditAmountTotal
                creditAmountUnit = this.formRef.current.getFieldValue('template1')[index-1].creditAmountUnit
                let biosPassword = this.formRef.current.getFieldValue('template1')[index-1].biosPassword
                biosPassword = biosPassword?biosPassword:''
                let serialNumbers = this.formRef.current.getFieldValue('template1')[index-1].serialNumbers
                let priceDropDate = this.formRef.current.getFieldValue('template1')[index-1].priceDropDate
                // let invoiceItemNo = this.formRef.current.getFieldValue('template1')[index-1].invoiceItemNo
                if(serialNumbers){
                    if(serialNumbers.length>1){
                        serialNumbers = serialNumbers.split(',')
                    }else if(serialNumbers.length==1){

                    }
                }
                //     if(this.state.key==2 || this.state.key==6 || this.state.key==11 || this.state.key==10){
                //         if(serialNumbers.length==quantity){
                //
                //         }else {
                //             check = 0
                //         }
                //     }
                // if(this.state.key===7){
                //     serialNumbers = this.state.ValidateData.invoiceItems[0].serialNumbers[0]
                //     quantity = this.state.ValidateData.invoiceItems[0].quantity
                // }
                //添加caseId字段
                if(this.state.key===2){
                    item={
                        ...item,
                        caseId: this.formRef.current.getFieldValue('template1')[index-1].caseId
                    }
                }
                if(this.state.key===7){
                    serialNumbers = item.serialNumbers[0]
                    quantity = item.quantity
                }
                if(this.state.key===4){
                    item={
                        ...item,
                        // quantity:item.invoiceItems[0].quantity,
                        creditAmountTotal:item.totalAmountValue,
                        // creditAmountUnit:item.invoiceItems[0].netValueUnit,
                        productDamaged:values.productDamaged?'X':'',
                        currency:item.invoiceItems[0].currency,
                        serialNumbers:serialNumbers?serialNumbers:'',
                        biosPassword:biosPassword,
                        priceDropDate:priceDropDate?(moment(priceDropDate).format('YYYY-MM-DD')):'',
                        invoiceItemNo:item.invoiceItems[0].invoiceItemNo,
                        // invoiceItemNo:invoiceItemNo?invoiceItemNo:undefined
                        // serialNumbers:this.formRef.current.getFieldValue('template1')[index-1].serialNumbers && this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length>1?this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.split(','):this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length==1?'':undefined,
                    }
                }else{
                    if(creditAmountUnit){
                        item={
                            ...item,
                            quantity:quantity,
                            creditAmountTotal:creditAmountTotal,
                            creditAmountUnit:creditAmountUnit,
                            productDamaged:values.productDamaged?'X':'',
                            serialNumbers:serialNumbers?serialNumbers:'',
                            biosPassword:biosPassword,
                            priceDropDate:priceDropDate?(moment(priceDropDate).format('YYYY-MM-DD')):'',
                            // invoiceItemNo:invoiceItemNo?invoiceItemNo:undefined
                            // serialNumbers:this.formRef.current.getFieldValue('template1')[index-1].serialNumbers && this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length>1?this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.split(','):this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length==1?'':undefined,
                        }
                    }else{
                        item={
                            ...item,
                            quantity:quantity,
                            creditAmountTotal:item.netValue,
                            creditAmountUnit:item.netValueUnit,
                            productDamaged:values.productDamaged?'X':'',
                            serialNumbers:serialNumbers?serialNumbers:'',
                            biosPassword:biosPassword,
                            priceDropDate:priceDropDate?(moment(priceDropDate).format('YYYY-MM-DD')):'',
                            // invoiceItemNo:invoiceItemNo?invoiceItemNo:undefined
                            // serialNumbers:this.formRef.current.getFieldValue('template1')[index-1].serialNumbers && this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length>1?this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.split(','):this.formRef.current.getFieldValue('template1')[index-1].serialNumbers.length==1?'':undefined,
                        }
                    }
                }
            }else if(index===0){
                values.quantity = this.formRef.current.getFieldValue('quantity')
                creditAmountTotal = this.formRef.current.getFieldValue('creditAmountTotal')
                creditAmountUnit = this.formRef.current.getFieldValue('creditAmountUnit')
                values.biosPassword = values.biosPassword?values.biosPassword:''
                if(values.serialNumbers){
                    if(values.serialNumbers.length>1){
                        values.serialNumbers=values.serialNumbers.split(',')
                    }else if(values.serialNumbers.length==1){

                    }
                }
                // if(this.state.key===7){
                //     values.serialNumbers = this.state.ValidateData.invoiceItems[0].serialNumbers[0]
                //     values.quantity = this.state.ValidateData.invoiceItems[0].quantity
                // }
                //添加caseId字段
                if(this.state.key===2){
                    item={
                        ...item,
                        caseId: values.caseId
                    }
                }
                if(this.state.key===7){
                    values.serialNumbers = item.serialNumbers[0]
                    values.quantity = item.quantity
                }
                if(this.state.key===4){
                    item={
                        ...item,
                        // quantity:item.invoiceItems[0].quantity,
                        creditAmountTotal:item.totalAmountValue,
                        // creditAmountUnit:item.invoiceItems[0].netValueUnit,
                        invoiceItemNo:item.invoiceItems[0].invoiceItemNo,
                        currency:item.invoiceItems[0].currency,
                        productDamaged:values.productDamaged?'X':'',
                        biosPassword:values.biosPassword,
                        serialNumbers:values.serialNumbers?values.serialNumbers:'',
                        priceDropDate:values.priceDropDate?(moment(values.priceDropDate).format('YYYY-MM-DD')):'',
                    }
                }else{
                    if(creditAmountTotal){
                        item={
                            ...item,
                            quantity:values.quantity,
                            productDamaged:values.productDamaged?'X':'',
                            biosPassword:values.biosPassword,
                            creditAmountTotal:creditAmountTotal,
                            creditAmountUnit:creditAmountUnit,
                            serialNumbers:values.serialNumbers?values.serialNumbers:'',
                            priceDropDate:values.priceDropDate?(moment(values.priceDropDate).format('YYYY-MM-DD')):'',
                        }
                    }else{
                        item={
                            ...item,
                            quantity:values.quantity,
                            productDamaged:values.productDamaged?'X':'',
                            biosPassword:values.biosPassword,
                            creditAmountTotal:item.netValue,
                            creditAmountUnit:item.netValueUnit,
                            serialNumbers:values.serialNumbers?values.serialNumbers:'',
                            priceDropDate:values.priceDropDate?(moment(values.priceDropDate).format('YYYY-MM-DD')):'',
                        }
                    }

                }
            }
            invoiceInfos.push(item)
        })
        if(this.state.key===13 && !selectedRows.length){
            invoiceInfos.push({
                soldToNumber:values.soldToNumber,
                poNumber:values.poNumber,
                partNumber:values.partNumber,
                quantity:values.quantity,
                priceDropDate:moment(values.priceDropDate).format('YYYY-MM-DD'),
                creditAmountUnit:values.creditAmountUnit,
                creditAmountTotal:values.creditAmountTotal,
                currency:values.currency,
            })
            values.template1 && values.template1.forEach(item=>{
                invoiceInfos.push({
                    soldToNumber:item.soldToNumber,
                    poNumber:item.poNumber,
                    partNumber:item.partNumber,
                    quantity:item.quantity,
                    priceDropDate:moment(item.priceDropDate).format('YYYY-MM-DD'),
                    creditAmountUnit:item.creditAmountUnit,
                    creditAmountTotal:item.creditAmountTotal,
                    currency:item.currency,
                })
            })
        }
        let template2Arr=[]
        if(values.template2){
            values.template2.forEach((item)=>{
                if(item.processing){
                    template2Arr.push({typeCode:'DFDSP',file:item.processing})
                }
                if(item.cf){
                    template2Arr.push({typeCode:'COFCF',file:item.cf})
                }
                if(item.snBox){
                    template2Arr.push({typeCode:'SNODB',file:item.snBox})
                }
                if(item.protocol){
                    template2Arr.push({typeCode:'SERPR',file:item.protocol})
                }
                if(item.DOAprotocol){
                    template2Arr.push({typeCode:'DOAPR',file:item.DOAprotocol})
                }
            })
        }
        let ccEmailAddressArry=[]
        if(values.template3){
            values.template3.forEach((item)=>{
                ccEmailAddressArry.push(item.ccEmailAddress)
            })
        }
        let attachments=[]
        let attachments_files = [
            {typeCode:'COFCF',file:values.cf ? values.cf : '',},
            {typeCode:'DFDSP',file:values.processing ? values.processing : ''},
            {typeCode:'SNODB',file:values.snBox ? values.snBox : ''},
            {typeCode:'DAMIM',file:values.damageImage ? values.damageImage : ''},
            {typeCode:'SERPR',file:values.protocol ? values.protocol : ''},
            {typeCode:'DOAPR',file:values.DOAprotocol ? values.DOAprotocol : ''}
        ]
        let attachmentsAll=[]
        attachments_files.forEach((item)=>{
            if(item.file){
                attachments.push(item)
                attachmentsAll = [...attachments,...template2Arr]
            }
        })
        let attachments_check=[]
        let COFCF_arr=[],DFDSP_arr=[],SNODB_arr=[],DAMIM_arr=[],SERPR_arr=[],DOAPR_arr=[]
        attachmentsAll.forEach(item=>{
            if(item.typeCode=="COFCF" && item.file){
                COFCF_arr.push(item.file)
            }else if(item.typeCode=="DFDSP" && item.file){
                DFDSP_arr.push(item.file)
            }else if(item.typeCode=="SNODB" && item.file){
                SNODB_arr.push(item.file)
            }else if(item.typeCode=="DAMIM" && item.file){
                DAMIM_arr.push(item.file)
            }else if(item.typeCode=="SERPR" && item.file){
                SERPR_arr.push(item.file)
            }else if(item.typeCode=="DOAPR" && item.file){
                DOAPR_arr.push(item.file)
            }
        })
        if(COFCF_arr.length){
            attachments_check.push({typeCode:'COFCF',attachments:COFCF_arr})
        }
        if(DFDSP_arr.length){
            attachments_check.push({typeCode:'DFDSP',attachments:DFDSP_arr})
        }
        if(SNODB_arr.length){
            attachments_check.push({typeCode:'SNODB',attachments:SNODB_arr})
        }
        if(DAMIM_arr.length){
            attachments_check.push({typeCode:'DAMIM',attachments:DAMIM_arr})
        }
        if(SERPR_arr.length){
            attachments_check.push({typeCode:'SERPR',attachments:SERPR_arr})
        }
        if(DOAPR_arr.length){
            attachments_check.push({typeCode:'DOAPR',attachments:DOAPR_arr})
        }
        let userId = window.localStorage.getItem('userId')
        if(this.state.key==6 && !values.MassUpload || this.state.key==11 && !values.MassUpload || this.state.key==10 && !values.MassUpload){
            // let serialNumber_length = values.serialNumbers.length
            // let quantity_number = values.quantity
            // if(serialNumber_length==quantity_number && check){
                values = {
                    ...values,
                    massUpload:values.MassUpload,
                    disputeType:disputeType,
                    disputeTypeText:disputeTypeText,
                    region:'WE',
                    businessUnit:"P",
                    createdBy:createdBy,
                    ccEmailAddress:[values.ccEmailAddress,...ccEmailAddressArry],
                    attachments:attachments_check,
                    serialNumbers:undefined,
                    invoiceInfos:values.MassUpload?this.state.MassUploadData:invoiceInfos,
                    MassUpload:undefined,
                    totalAmountValue:this.state.totalAmountValue,
                    country:this.state.soldToCountry,
                    contactPersonCountry:values.contactPersonCountry || this.state.soldToCountry,
                    requesterId:values.requesterId?values.requesterId:userId,
                    processing:undefined,
                    cf:undefined,
                    quantity:undefined,
                    shipToNumber:undefined,
                    billToNumber:undefined,
                    deliveryNumber:undefined,
                    soldToNumber:undefined,
                    poNumber:undefined,
                    orderNumber:undefined,
                    partNumber:undefined,
                    invoiceNumber:undefined,
                    priceDropDate:values.priceDropDate?(moment(values.priceDropDate).format('YYYY-MM-DD')):'',
                }
                // console.log(values)
                if(values.invoiceInfos.length){
                    dispute_submit(values).then((res)=>{
                        if(res.retCode==="200"){
                            message.success(`${res.retMsg}`)
                            this.setState({loading:false})
                            this.props.history.push({
                                pathname: '/successful',
                                state: { data:res.data },
                            })
                        }else{
                            message.warn(`${res.retMsg}`)
                            this.setState({loading:false})
                        }
                    }).catch(()=>{
                        this.setState({loading:false})
                    })
                }else{
                    this.setState({loading:false})
                    message.warn('No invoice data, you can not submit the dispute, pls check it!')
                }

            // }
            // else{
            //     message.warn('The number of SN should be equal to the PN qty')
            //     this.setState({loading:false})
            // }
        }else{
            values = {
                ...values,
                massUpload:values.MassUpload,
                disputeType:disputeType,
                disputeTypeText:disputeTypeText,
                region:'WE',
                businessUnit:"P",
                createdBy:createdBy,
                ccEmailAddress:[values.ccEmailAddress,...ccEmailAddressArry],
                attachments:attachments_check,
                serialNumbers:undefined,
                invoiceInfos:values.MassUpload?this.state.MassUploadData:invoiceInfos,
                comments:this.state.key===4?values.requestedChanges:values.comments,
                MassUpload:undefined,
                totalAmountValue:this.state.totalAmountValue,
                country:this.state.soldToCountry,
                contactPersonCountry:values.contactPersonCountry || this.state.soldToCountry,
                requesterId:values.requesterId?values.requesterId:userId,
                processing:undefined,
                cf:undefined,
                quantity:undefined,
                shipToNumber:undefined,
                billToNumber:undefined,
                deliveryNumber:undefined,
                soldToNumber:undefined,
                caseId:undefined,
                poNumber:undefined,
                orderNumber:undefined,
                partNumber:undefined,
                invoiceNumber:undefined,
                priceDropDate:undefined,
            }
            if(values.invoiceInfos.length){
                dispute_submit(values).then((res)=>{
                    if(res.retCode==="200"){
                        message.success(`${res.retMsg}`)
                        this.setState({loading:false})
                        this.props.history.push({
                            pathname: '/successful',
                            state: { data:res.data },
                        })
                    }else{
                        message.warn(`${res.retMsg}`)
                        this.setState({loading:false})
                    }
                }).catch(()=>{
                    this.setState({loading:false})
                })
            }else{
                this.setState({loading:false})
                message.warn('No invoice data, you can not submit the dispute, pls check it!')
            }
        }

    };
    onFinishFailed = (errorInfo) => {
        errorInfo.errorFields.forEach(item=>{
            message.warn(`${item.errors}`)
        })
        console.log('Failed:', errorInfo);
    };
    //msg modal
    MsgHandleOk = () => {
        this.setState({MsgModalVisible:false})
    }
    MsgHandleCancel = () =>{
        this.setState({MsgModalVisible:false})
    }
    render() {
        let dispute_types_list = JSON.parse(window.sessionStorage.getItem('we_p_dispute_types'))
        const {disputeType,PPMass_checked,selectedRowKeys,isModalVisible,MsgModalVisible,invoice_number,serial_number,InvoiceClaimMsg,ValidateData}=this.state;
        return <div>
            <div className="example" style={{display:this.state.loading?'block':'none'}}>
                <Spin spinning={this.state.loading} />
            </div>
            <HeaderNav parmas={'/wepcgcustomers'}/>
            <Modal footer={null} title={
                this.state.key===4?this.state.rebillTitle
                    :this.state.key===2?this.state.lostUnitsTitle
                    :this.state.key===6?this.state.boxDamageTitle
                    :this.state.key===10?this.state.productDamageTitle
                    :this.state.key===3?this.state.pricingErrorTitle :''}
                   visible={MsgModalVisible} onOk={this.MsgHandleOk} onCancel={this.MsgHandleCancel}>
                {this.state.key===4?
                    <div>
                        <h4>Pls provide required below information :</h4>
                        <p>1. Required Change description (Sold to, Bill to, Ship to, PO, VAT ID, VAT rate)</p>
                        <p>2. Reason description</p>
                    </div>
                    :this.state.key==2?
                    <div>
                        <h4>Please provide required below:</h4>
                        <p>1. POD</p>
                        <p>2. If partial loss - SN required</p>
                    </div>
                    :this.state.key==3?
                    <div>
                        <p>
                            If the issue is related to an unapplied BID or to a wrong bid pricing, please advise a BID number or upload a copy of the BID.
                        </p>
                    </div>
                    :this.state.key===6 || this.state.key===10?
                    <div>
                        <h4>Pls provide required below information :</h4>
                        <p>1. Photo is mandatory (in Photo format)</p>
                        <p>2. Include SN/Label, Damage should be visible on image</p>
                    </div>:''
                }
            </Modal>
            <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1 className={'big_title'}>WE-PCG Customers</h1>
                    <DropDownBox regionUnit={'wep'} optionList={dispute_types_list} callback = { this.handleChange.bind(this) }/>
                    <Form
                        name="WE-PCG-Customers"
                        labelCol={{ span: 8 , offset:2}}
                        wrapperCol={{ span: 10}}
                        ref={this.formRef}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        initialValues={{ remember: true }}
                        preserve={false}
                    >
                        {( ()=>{
                                switch(this.state.key){
                                    case this.state.key:
                                        if(this.state.key>0 && this.state.key!=9 && this.state.key!=12){
                                            return <Template1 type={this.state.key} formRef={this.formRef}
                                                              ValidateData={ValidateData}
                                                              SKID={this.SKID.bind(this)}
                                                              isSKID={this.state.isSKID}
                                                              MassUploadData={this.MassUploadData.bind(this)}
                                                              onCreditAmountTotal={this.onCreditAmountTotal.bind(this)}
                                                              dataChecked = {this.dataChecked.bind(this)}
                                                              selectedRowKeys={selectedRowKeys}
                                                              isModalVisible={isModalVisible}
                                                              handleCancel = {this.handleCancel.bind(this)}
                                                              ModalVisible={this.ModalVisible}
                                                              getInvoiceClaim={this.getInvoiceClaim.bind(this)}
                                                              onRebillInvoice={this.onRebillInvoice.bind(this)}
                                                              invoice_number={invoice_number}
                                                              serial_number={serial_number}
                                                              InvoiceClaimMsg={InvoiceClaimMsg}
                                                              PPMass={this.PPMass.bind(this)}
                                                              PPMass_checked={PPMass_checked}
                                                              disputeType={disputeType}
                                                              deleteFirstData={this.deleteFirstData.bind(this)}
                                                              deleteData={this.deleteData.bind(this)}
                                                              callback = { this.callback.bind(this) }/>;
                                        }
                                        break;
                                    default:
                                        return '';
                                }
                            }
                        )()}
                        {
                            this.state.key>0?
                                <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Form.Item> :''
                        }

                    </Form>

                </Content>
                <Sider className="site-layout-background" width={300}>
                    {this.state.key==1?
                        <EligibleLateDeliveryBar />:
                        this.state.key==2?
                            <LostUnitsBar />:
                            this.state.key==3?
                                <PricingErrorBar />:
                                this.state.key==4?
                                    <RebillBar />:
                                this.state.key==5?
                                    <ServiceSoftwareCancellationBar />:
                                this.state.key==6?
                                    <BoxDamageBar />:
                                this.state.key==7?
                                    <DeadOnArrivalBar />:
                                this.state.key==8?
                                    <FaultyOptionsUnderWarrantyBar />:
                                this.state.key==10?
                                    <ProductDamageBar />:
                                this.state.key==11?
                                    <OtherBar />:
                                this.state.key==13?
                                    <PriceProtectionDisputeBar />:''
                    }
                </Sider>
            </Layout>
        </div>
    }
}

export default WEPCGCustomers;